import React, { Component } from 'react'
import styled from 'styled-components'
import {
  Header,
  Card,
  Icon,
  StyledImage,
  XCMText,
  XXLText,
  FlexWrapper,
  Toast,
  Modal,
  FormikForm,
  TextArea,
  Button,
  Span
} from '../components'
import { Formik, Field } from 'formik'
import { API_URL } from '../constants'
import axios from 'axios'
import Cookies from 'js-cookie'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const TopWrapper = styled.div`
  background: #078489;
  border-radius: 0 0 50% 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 11.2% 0 17.4%;
  margin-top: 60px;
`

class SpreadWord extends Component {
  state = { showModal: false, userData: {}, openToast: false }

  async componentDidMount() {
    try {
      const { data } = await axios.get(`${API_URL}/users/gererate-referral-code/${Cookies.get('user_id')}`)
      this.setState({ userData: data })
    } catch (error) {
      console.log(error)
    }
  }
  handleClose = async (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    await this.setState({ openToast: false })
  }

  render() {
    const { showModal, userData, openToast } = this.state
    const urlArr = window.location.href.split('/')
    const fpUrl = urlArr[0] + '//' + urlArr[2]
    // const userDetails = Cookies.getJSON('userDetails')
    return (
      <React.Fragment>
        <Header
          title={'Spread the Word'}
          icon="arrowBack"
          onClickBack={() => this.props.history.replace('/user-profile')}
          color="#fff"
        />
        <TopWrapper>
          <StyledImage src={require('../static/images/new_logo@3x.png')} height="104px" />
        </TopWrapper>
        <FlexWrapper
          viewPadding="0px 30px"
          height={'calc(100% - 50%)'}
          alignItems="center"
          justifyContent="space-evenly">
          <FlexWrapper justifyContent="center" alignItems="center" viewPadding="0 0 0px">
            <XCMText>Share your invite link</XCMText>
            <XXLText>Loren Ipsum is simply dummy text of the printing and typesetting industry</XXLText>
          </FlexWrapper>
          <Card boxShadow=" 0 2px 4px 0 rgba(0, 0, 0, 0.16)" boxRadius="100px" padding="12px 18px" margin="00 0 0">
            <FlexWrapper direction="row" alignItems="center" justifyContent="space-between">
              {/*  <XMText
                ref={this.copyRef}
                dangerouslySetInnerHTML={this.createMarkeup(`${fpUrl}/auth/signup?ref=${userData.referralCode}`)}
              /> */}
              <CopyToClipboard text={'https://app.greenchoice.io'} onCopy={() => this.setState({ openToast: true })}>
                <Span>
                  https://app.greenchoice.io
                  <Icon icon="copyToClipboard" />
                </Span>
              </CopyToClipboard>
              {/*  <div onClick={() => this.copyToClipboard(`${fpUrl}/auth/signup?ref=${userData.referralCode}`)}>
                <Icon icon="copyToClipboard" />
              </div> */}
            </FlexWrapper>
          </Card>
          <FlexWrapper direction="row" alignItems="center" justifyContent="space-between" viewPadding="0 0 0 0">
            <StyledImage
              alt="social"
              height="44px"
              src={require('../static/svgs/email.svg')}
              onClick={() => {
                window.location.href = `mailto:?body=${fpUrl}/auth/signup?ref=${userData.referralCode}`
              }}
            />

            <StyledImage
              alt="social"
              height="44px"
              src={require('../static/svgs/whatsapp.svg')}
              onClick={() => {
                window.location.href = `https://wa.me/?text=Hi%20there!%20${fpUrl}/auth/signup?ref=${
                  userData.referralCode
                }`
              }}
            />
            <StyledImage
              alt="social"
              height="44px"
              src={require('../static/svgs/facebook.svg')}
              onClick={() => {
                window.open(
                  `https://www.facebook.com/sharer/sharer.php?u=${fpUrl}/auth/signup?ref=${userData.referralCode}`
                )
              }}
            />
            <StyledImage
              alt="social"
              height="44px"
              src={require('../static/svgs/message.svg')}
              onClick={() => {
                window.open(`sms:?&body=${fpUrl}/auth/signup?ref=${userData.referralCode}`)
              }}
            />
          </FlexWrapper>
        </FlexWrapper>
        <Modal
          title={'Send email invites'}
          show={showModal}
          hide={!showModal}
          onClose={() => this.setState({ showModal: false })}>
          <FlexWrapper alignItems="center">
            <React.Fragment>
              <Formik
                enableReinitialize
                initialValues={{ emails: '' }}
                validateOnChange
                render={formikBag => (
                  <FormikForm>
                    <Field
                      name="title"
                      render={({ field }) => (
                        <TextArea {...field} placeholder="Enter email addresses" paddingTop="40px" />
                      )}
                    />
                    <FlexWrapper alignItems="center">
                      <Button
                        size="small"
                        label="Send invites"
                        namespace="Send Invites"
                        volume="filled"
                        margin="14px 0 0 0"
                        type="submit"
                      />
                    </FlexWrapper>
                  </FormikForm>
                )}
              />
            </React.Fragment>
          </FlexWrapper>
        </Modal>
        <Toast open={openToast} message="Copied to clipboard!" onClose={this.handleClose} />
      </React.Fragment>
    )
  }
}

export default SpreadWord



// WEBPACK FOOTER //
// ./src/pages/SpreadWord.js